export const defaultlang = [
    {
        value: 'en',
        lang: 'English'
    },
    {
        value: 'th',
        lang: 'Thai'
    }
]
